export default __webpack_public_path__ + "eb080b6.png";